<template>
    <div class="property-saved-searches-wrapper">
        <div
            class="property-saved-searches vld-parent"
            :class="{
                'container': !isMobile,
                'px-0': isMobile
            }"
            >
            <div v-if="propertySearchFilterAppResources.length > 0">
                        <h2 class="my-3 d-none d-md-flex">
                            Saved Searches
                        </h2>
                    <div>
                        <property-saved-searches-edit-modal />
                        <delete-saved-search-modal />
                        <property-saved-searches-card
                                v-for="propertySearchFilterAppResource in propertySearchFilterAppResources"
                                :key="propertySearchFilterAppResource._uuid"
                                :property-search-filter-app-resource="propertySearchFilterAppResource"
                        />
                    </div>
            </div>
            <element-loader :loading="!isLoaded" />
        </div>
        <div class="workspace-footer d-flex">
            <div class="container mr-xl-0">
                <div class="logo d-flex flex-row justify-content-center m-0">
                    <b-link
                            :href="privacyPolicyUrl"
                            target="_blank"
                            class="text-underline"
                    >
                        Privacy Policy
                    </b-link>
                    <b-link
                            :href="links.termsOfUse"
                            target="_blank"
                            class="text-underline m-0"
                    >
                        Terms of Use
                    </b-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import './PropertySavedSearches.scss';
    import ApiFilter from "@milestoneslabs/milestones-js-engine/src/Api/ApiFilter";
    import {store} from "../../../index";
    import PropertySearchFilterSearchRepository from "../../../fixtures/PropertySearchFilterSearchRepository";
    import ShowNotificationMixin from '@milestoneslabs/milestones-ui-kit/src/mixins/ShowNotificationMixin';
    import AppResourceCollection from "@milestoneslabs/milestones-js-engine/src/Data/AppResourceCollection";
    import {PROPERTY_SAVED_SEARCHES_CARD_HEADER_DELETE}
        from "./GroupPropertySavedSearchesCard/PropertySavedSearchesCardHeader/PropertySavedSearchesCardHeader";
    import {PROPERTY_SAVED_SEARCHES_EDIT_MODAL_SAVED}
        from "./GroupPropertySavedSearchesCard/PropertySavedSearchesEditModal/PropertySavedSearchesEditModal";
    import {
        PROPERTY_SEARCH_START_SEARCHING_DISPLAY
    } from '../GroupPropertySearchHeader/PropertySearchHeader/PropertySearchHeader';
    import IsMobileMixin from "@milestoneslabs/milestones-ui-kit/src/mixins/IsMobileMixin";
    import SavedSearchAlertsMixin from "../../mixins/SavedSearchAlertsMixin";
    import SearchAlertSubscriberAppResource
        from "@milestoneslabs/milestones-core-js/src/AppResources/SearchAlertSubscriberAppResource";
    import {
        privacyPolicy,
        termsOfUse
    } from "@milestoneslabs/milestones-ui-kit/src/helpers/externalLinks";

    export const PROPERTY_SAVED_SEARCHES_DISPLAY_MAP = 'PropertySavedSearches:display-map';

    import PropertySavedSearchesCard from './GroupPropertySavedSearchesCard/PropertySavedSearchesCard';
    import PropertySavedSearchesEditModal
        from './GroupPropertySavedSearchesCard/PropertySavedSearchesEditModal/PropertySavedSearchesEditModal';
    import DeleteSavedSearchModal from './DeleteSavedSearchModal/DeleteSavedSearchModal';
    import {mapGetters} from 'vuex';

    export default {
        name: "PropertySavedSearches",

        components: {
            PropertySavedSearchesEditModal,
            PropertySavedSearchesCard,
            DeleteSavedSearchModal,
        },

        mixins: [
            IsMobileMixin,
            ShowNotificationMixin,
            SavedSearchAlertsMixin,
        ],

        data() {
            return {
                links: {
                    privacyPolicy: privacyPolicy,
                    termsOfUse: termsOfUse,
                },
                propertySearchFilterAppResources: new AppResourceCollection('property-search-filter'),
                isLoaded: false,
                imagePath: require('./saved_searches.png')
            };
        },

        beforeMount() {
            if (this.$route.query && this.$route.query.unsubscribe) {
                this.unsubscribeAlert();
            } else {
                this.fetchPropertySearchFilterAppResources();
            }
            this.$bus.$on(PROPERTY_SAVED_SEARCHES_CARD_HEADER_DELETE, this.fetchPropertySearchFilterAppResources);
            this.$bus.$on(PROPERTY_SAVED_SEARCHES_EDIT_MODAL_SAVED, this.fetchPropertySearchFilterAppResources);
        },

        beforeDestroy() {
            this.$bus.$off(PROPERTY_SAVED_SEARCHES_CARD_HEADER_DELETE, this.fetchPropertySearchFilterAppResources);
            this.$bus.$off(PROPERTY_SAVED_SEARCHES_EDIT_MODAL_SAVED, this.fetchPropertySearchFilterAppResources);
        },

        computed: {
            ...mapGetters({
                currentOrganization: 'getOrganization',
            }),
            privacyPolicyUrl() {
                return this.currentOrganization?.privacyPolicyUrl || this.links.privacyPolicy;
            }
        },

        methods: {
            async fetchPropertySearchFilterAppResources() {
                let propertySearchFilterRepository = new PropertySearchFilterSearchRepository();
                propertySearchFilterRepository.setSearchData({
                    pagination: 'disabled',
                    orderBy: {
                        createdAt: 'DESC',
                    },
                    include: [
                        'searchAlertSubscribers.projectMember.user',
                        'searchAlertSubscribers.projectMember.workspaceMembershipType',
                    ],
                    filter: new ApiFilter({
                        params: {
                            projectUuid: store.getters.getWorkspaceUuid,
                        },
                    })
                }, false);
                try {
                    await propertySearchFilterRepository.search();
                    this.propertySearchFilterAppResources = propertySearchFilterRepository.appResourceCollection.toArray();
                } catch (e) {
                    this.showNotification({
                        message: 'Something went wrong. Please try again later',
                        type: 'error'
                    });
                    console.error(e);
                }

                if (this.propertySearchFilterAppResources.length === 0) {
                    this.$bus.$emit(PROPERTY_SEARCH_START_SEARCHING_DISPLAY, true);
                }

                this.isLoaded = true;
            },

            async unsubscribeAlert() {
                let subscriber = new SearchAlertSubscriberAppResource({uuid: this.$route.query.unsubscribe});

                try {
                    await subscriber.fetch();
                    subscriber.enabled = false;
                    await subscriber.save();
                    this.showNotification({
                        message: 'Disabled Saved Search alerts',
                        type: 'success'
                    });
                } catch (e) {
                    this.showNotification({
                        message: 'Could not disable Saved Search alerts. Please try again later',
                        type: 'error'
                    });
                    console.error(e);
                } finally {
                    await this.fetchPropertySearchFilterAppResources();
                }
            }
        },
    };
</script>
